__turbopack_context__.v({
  "container": "CreateApplicationBlock-module-scss-module__A72m0G__container",
  "title": "CreateApplicationBlock-module-scss-module__A72m0G__title",
});
